import { FC } from "react";
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Descriptions, Modal } from 'antd';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  movieUrl: string|undefined;
}

const ShowMovieModal: FC<IProps> = ({
  visible, setVisible, movieUrl
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title={t('homepage.mainBanner.title3')}
      visible={visible}
      onCancel={() => setVisible(false)}
      footer={[
        <div className='comm-btn__area justify-content-center'>	
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={() => setVisible(false)}
          >
            {t('common.button.close')}
          </AntButton>
        </div>
      ]}
    >
      <div className="text-center">
        <video controls width="400">
          <source src={movieUrl} type="video/mp4" />
        </video>
        <Descriptions
          bordered
          size="small"
        >
          <Descriptions.Item label={t('homepage.education.column4')}>
            {movieUrl}
          </Descriptions.Item>
        </Descriptions>
      </div>
    </Modal>
  );
}

export default ShowMovieModal;
